import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DateFormatterService } from 'src/app/shared/components/date-picker/date-formatter.service';
import { CaseService } from 'src/app/shared/services/case.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';

@Component({
  selector: 'app-company-violation',
  templateUrl: './company-violation.component.html',
  styleUrls: ['./company-violation.component.scss']
})
export class CompanyViolationComponent implements OnInit {
  MainViolationsArr: any;
  eCaseId: any;
  ViolationsArr: any;
  mainViolationTypeId: any;
  subViolationTypeId: any;
  MainViolation: any;
  SubViolation: any;
  ViolationDescription: any;
  isAdd: boolean = false;
   
  ViolationIdDelete: any;
  violationIdEdit: any;
  isInsert:boolean=false;
  mainViolationTypeName: any;
 
  constructor(private dateformat: DateFormatterService, private sharedService: SharedHttpService, public route: Router, public lookupService: LookupService, public toastr: NotificationService, public caseService: CaseService) { }
  @Input() loadDataFP: Observable<any>;
  ngOnInit(): void {

      this.loadDataFP.subscribe((data) => {
          setTimeout(() => {
              this.loadData();
          }, 100);

      });

}

  loadData() {
    this.eCaseId = this.caseService.case.eCaseId;
  
    this.isAdd = false;
    this.isInsert = false;

    this.getMainViolation();
    this.sharedService.get(`api/Violation/GetCaseViolations?eCaseId=${this.eCaseId}`).subscribe(res => {
      this.ViolationsArr = res;
    });
  }
 

 
  getMainViolation() {
      this.sharedService.get(`api/Violation/GetMainViolations?CaseTypeId=${this.caseService.case.caseTypeId}`).subscribe(res => {
      this.MainViolationsArr = res;
    });
 }
 
 
 
  CreateViolation(modal) {
    this.isInsert=true;
    this.mainViolationTypeId=undefined;
    this.ViolationDescription=undefined;
     this.sharedService.openSmall(modal);
  }
  
  onCreateViolation(modal) {
    let url = 'api/Violation/Insert';
    let objectAdded = {
      "caseId": this.caseService.case.caseId,
      "mainViolationTypeId": this.mainViolationTypeId,
      "material": this.ViolationDescription,
      "otherAction": null,
      "location": null,
      "place": null,
      "quantity": null,
      "initalValue": null,
      "measurmentUnitId": null,
      "otherMeasurmentUnit": null,
      "violationActionId": null,
      "reachingViolationsMehod": null,
      "dateOfBuy": null,
      "purchaseSource": null,
    }

    this.sharedService.post(url, [objectAdded]).subscribe(
      (response) => {
        modal.dismiss('Cross click');
        this.loadData();
        this.sharedService.showSuccessKey("CreatedSuccessfully");

      },

    );
  }

  EditViolation(violation, modal) {
    this.isInsert=false;
    this.violationIdEdit = violation.violationId;
    this.mainViolationTypeId = violation.mainViolationTypeId;
    this.ViolationDescription = violation.material;
    this.sharedService.openSmall(modal);
  }

  onEditViolation(modal) {
    let url = 'api/Violation/Update';
    let objectAdded = {
      "caseId": this.caseService.case.caseId,
      "violationId":this.violationIdEdit,
      "mainViolationTypeId": this.mainViolationTypeId,
      "material": this.ViolationDescription,
      "otherAction": null,
      "location": null,
      "place": null,
      "quantity": null,
      "initalValue": null,
      "measurmentUnitId": null,
      "otherMeasurmentUnit": null,
      "violationActionId": null,
      "reachingViolationsMehod": null,
      "dateOfBuy": null,
      "purchaseSource": null,
    }

    this.sharedService.put(url, [objectAdded]).subscribe(
      (response) => {
        modal.dismiss('Cross click');
        this.loadData();
        this.sharedService.showSuccessKey("EditedSuccessfully");

      },

    );
  }

  DeleteViolation(Id: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.ViolationIdDelete = Id;

  }

  onDeleteViolation(modal) {
    let url = 'api/Violation/Delete';
    this.sharedService.delete(url, [this.ViolationIdDelete]).subscribe(
      (response) => {
        modal.dismiss('Cross click');
        this.sharedService.showSuccessKey("DeletedSuccessfully");
        this.loadData();
      },

    );
  }

}
